import React from 'react'
import ClassNames from 'classnames'
import { InputStyle } from './styled'

/**
 * Input description
 * - ...
 */

export class Input extends React.PureComponent {
  render() {
    const {
      className,
      label,
      value,
      type,
      id,
      name,
      placeholder,
      isHorizontal,
      isDisable,
      disabled,
      isDisabled,
      readOnly,
      isReadOnly,
      onChange,
      defaultValue,
      minLength,
      min,
      maxLength,
      max,
      pattern,
      onFocus,
      onKeyDown,
      autoComplete = 'on',
      style,
      onBlur,
      onKeyPress,
    } = this.props

    return (
      <InputStyle
        className={ClassNames(
          'input-control',
          { 'is-horizontal': isHorizontal },
          { 'is-disabled': isDisable || disabled || isDisabled },
          { 'is-read-only': readOnly || isReadOnly },
          className
        )}
      >
        {label && (
          <label className="label" htmlFor={id}>
            {label}
          </label>
        )}
        <input
          className="input"
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          disabled={isDisable || disabled || isDisabled}
          value={value}
          readOnly={readOnly || isReadOnly}
          onChange={onChange}
          minLength={minLength}
          min={min}
          max={max}
          maxLength={maxLength}
          pattern={pattern}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          autoComplete={autoComplete}
          defaultValue={defaultValue}
          style={style}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
        />
      </InputStyle>
    )
  }
}
